// @core/api/endpoints/document/get_version.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  VersionResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Get version
 * Retrieves a specific document version snapshot.
 */
export async function GetVersion(
  target_type: string,
  target_id: string,
  version_id: string,
  options?: RequestOptions
): Promise<VersionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/documents/:target_type/:target_id/versions/:version_id`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  requestPath = requestPath.replace(':version_id', encodeURIComponent(version_id));
  const requestOptions = options;
  return client.get<VersionResponse>(requestPath, { ...requestOptions });
}
